/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
require('@atlaskit/css-reset/bundle.css');
require('@atlaskit/reduced-ui-pack');

import React from 'react';

import { token } from '@atlaskit/tokens';

import unsupported from './unsupported.svg';
import messages from './messages.json';
import { i18n } from './i18n';

const DEFAULT_LOCALE = 'en-US';

export function BrowserNotSupported() {
	const locale = window?.__INITIAL_STATE__?.i18n?.locale || DEFAULT_LOCALE;
	const translations = messages[locale] || messages[DEFAULT_LOCALE];
	return (
		<div
			style={{
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				height: '100vh',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				display: 'flex',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				alignItems: 'center',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				justifyContent: 'center',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				flexDirection: 'column',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				textAlign: 'center',
			}}
		>
			<img
				src={unsupported}
				alt={translations[i18n.title.id]}
				// The image is not visually centered
				style={{ marginLeft: -20 }}
			/>
			<h1
				style={{
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					fontSize: '1.3em',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					fontWeight: token('font.weight.medium'),
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					padding: '20px 0',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					margin: 0,
				}}
			>
				{translations[i18n.title.id]}
			</h1>
			<div>
				<a
					href="http://go.atlassian.com/cloud-unsupported-browser"
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className="ak-button ak-button__appearance-default"
				>
					{translations[i18n.viewSupported.id]}
				</a>
			</div>
		</div>
	);
}
